export const CTP_ONBOARDING_STAGE = {
	TIMELINE: 'TIMELINE',
	CREATE_ISSUE: 'CREATE_ISSUE',
	TEAMS: 'TEAMS',
	BOARDS: 'BOARDS',
	CLOSED: 'CLOSED',
} as const;
